export default __webpack_public_path__ + "static/media/coffee.95eedefd.png";